import { FilterDatatable, FilterOptionValue } from '@europrocurement/flexy-datatable';

/**
 * Génère un filtre `staticSelect` (liste d'options figée) pour les listings du module Offres.
 * Mutualise le helper jusque-là dupliqué dans chaque Panel.
 */
export const getStaticSelectFilter = (
    label: string,
    field: string,
    options: FilterOptionValue[],
): FilterDatatable => ({
    label,
    field,
    type: 'staticSelect',
    options,
    renderFilterList: (value: string) => {
        const selectedOption = options.find((option) => option.value === value);
        return selectedOption ? selectedOption.label : 'Aucun';
    },
});

export default getStaticSelectFilter;
